"use strict";
/**
 * API helper functions for Permissions Management endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
exports.permissionApi = {
    /**
     * Fetch all permission assignments
     */
    getAll() {
        return apiClient_1.apiClient
            .get('/permissions')
            .then(res => { var _a; return (_a = res.permissionsData) !== null && _a !== void 0 ? _a : []; });
    },
    /**
     * Fetch all permission type definitions (the permission code catalogue)
     */
    getAllPermissionTypes() {
        return apiClient_1.apiClient
            .get('/allPermissions')
            .then(perms => [...(perms !== null && perms !== void 0 ? perms : [])].sort((a, b) => (a.code > b.code ? 1 : -1)));
    },
    /**
     * Create a new permission assignment
     */
    create(data) {
        return apiClient_1.apiClient.post('/permission', data);
    },
    /**
     * Update an existing permission assignment
     */
    update(data) {
        return apiClient_1.apiClient.put('/permission', data);
    },
    /**
     * Delete a permission assignment by ID.
     * retry: false — avoids retrying destructive operations on 500
     */
    deletePermission(id) {
        (0, validation_1.validateId)(id, 'Permission ID');
        return apiClient_1.apiClient.delete(`/permission/${id}`, { retry: false });
    },
};
